/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_RCHRGE_DATA,
  SET_TAX_DATA,
  SET_TURNOVER_DATA,
  SET_TAXRATE_DATA,
  SET_CLEAR_GRAPH,
  SET_GSTR1_NIL_DATA
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  rchrgeData: [],
  taxData: [],
  turnOverData: [],
  taxRateData: [],
  gstr1NilTableData: []
};

/* eslint-disable default-case, no-param-reassign */
const TurnOverReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_RCHRGE_DATA:
      return {
        ...state,
        rchrgeData: action.rchrgeData
      };
    case SET_TAX_DATA:
      return {
        ...state,
        taxData: action.taxData
      };
    case SET_GSTR1_NIL_DATA:
      return {
        ...state,
        gstr1NilTableData: action.gstr1NilTableData
      };
    case SET_TURNOVER_DATA:
      return {
        ...state,
        turnOverData: action.turnOverData
      };
    case SET_TAXRATE_DATA:
      return {
        ...state,
        taxRateData: action.taxRateData
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        rchrgeData: [],
        taxData: [],
        turnOverData: [],
        taxRateData: []
      };
    default:
      return state;
  }
};

export default TurnOverReducer;
